import { format, isValid, parseISO, startOfWeek } from "date-fns"

import { addDaysToDateString, ukToday } from "../../../shared/shift-timing.ts"

const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

export const mondayOf = (date: string): string =>
  format(startOfWeek(parseISO(date), { weekStartsOn: 1 }), "yyyy-MM-dd")

export const thisWeek = (today: string = ukToday()): string => mondayOf(today)

export const lastWeek = (today: string = ukToday()): string =>
  addDaysToDateString(thisWeek(today), -7)

// A week in the URL that isn't a Monday falls back to last week rather than reconciling a shifted week.
export const weekFrom = (param: string | null, today: string = ukToday()): string =>
  param && DATE_PATTERN.test(param) && isValid(parseISO(param)) && mondayOf(param) === param
    ? param
    : lastWeek(today)

export const formatWeek = (monday: string): string =>
  `${format(parseISO(monday), "EEE d MMM")} - ${format(parseISO(addDaysToDateString(monday, 6)), "EEE d MMM yyyy")}`
